import React from "react";
import { connect } from "react-redux";

import { pullCampaignOffices, setFocusedMembership } from "../../../store/api/calls";
import {
  clearCampaignAggCache,
  clearCampaignCanvassersCache,
  clearCampaignOfficeCache,
  clearCampaignSitesCache,
  clearDashboardOptions,
  clearSiteCanvassCache,
} from "../../../store/actions";
import { withRouter } from "../../../utils/withRouter";

class CampaignSelector extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.focusedCampaign.id !== this.props.focusedCampaign.id) {
      this.refresh(this.props.focusedCampaign.id);
    }
  }

  renderOptions() {
    // obvious users should not be providing dupes, but let's just handle it globally here
    const seen = new Set();
    let options = this.props.campaigns
      .filter((d) => {
        if (seen.has(d.id)) return false;
        seen.add(d.id);
        return true;
      })
      .map((d) => (
        <option key={d.id} value={d.id}>
          {d.name}
        </option>
      ));

    return options;
  }

  handleChange = (ev) => {
    const value = parseInt(ev.target.value);
    this.refresh(value);
    this.props.history.push("/");
  }

  refresh(id) {
    this.props.clearCampaignAggCache();
    this.props.clearDashboardOptions();
    this.props.clearSiteCanvassCache();
    this.props.clearCampaignCanvassersCache();
    this.props.clearCampaignSitesCache();
    this.props.clearCampaignOfficeCache();
    setFocusedMembership(id);
    pullCampaignOffices();
  }

  render() {
    return (
      <select
        id="campaign-select"
        className={this.props.disabled ? "disabled" : ""}
        value={this.props.focusedCampaign.id}
        onChange={this.handleChange}
        style={{ width: "300px" }}
      >
        {this.renderOptions()}
      </select>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedCampaign: state.session.focusedCampaign,
  campaigns: state.campaigns.data,
});

const mapDispatchToProps = (dispatch) => ({
  clearSiteCanvassCache: () => dispatch(clearSiteCanvassCache()),
  clearCampaignCanvassersCache: () => dispatch(clearCampaignCanvassersCache()),
  clearCampaignSitesCache: () => dispatch(clearCampaignSitesCache()),
  clearCampaignOfficeCache: () => dispatch(clearCampaignOfficeCache()),
  clearCampaignAggCache: () => dispatch(clearCampaignAggCache()),
  clearDashboardOptions: () => dispatch(clearDashboardOptions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CampaignSelector));
